module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAALCAYAAAByF90EAAAAAXNSR0IArs4c6QAAAMlJREFUKBWV0SEOwjAUBuD/dTAzxymwyAULDofmDCRwDxIkgiPgkFgyyU3mJmgGZX/JljG2N2jS1Pzv62sf0LOyeDPh7olBtACBJx4XZgyCWZTsbl35TqhCnBv5YpFUw1qhOiIQS8jBhVCwL6iJiGDpIYeThn1AbUiU7M+Esni9cApWQRpCiEvDPPQL8qa6MbnH27FFfkUxHX4s/6R8TlncPJudhRhMjZV89Q9ClBfxQj/RogEaZmjMsRjrITCY93VS74xZ1rCWxgsNAZZY+nRQuQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Gotit/path.png
// module id = +vDJ
// module chunks = 0